import classNames from 'classnames';
import styled from 'styled-components';

import type { CardQuality } from '__generated__/globalTypes';
import { Sparkles } from 'atoms/animations/Sparkles';
import { Star } from 'atoms/icons/Star';
import { ConditionalWrapper } from 'atoms/layout/ConditionalWrapper';
import { Horizontal } from 'atoms/layout/flex';
import { range } from 'lib/arrays';
import { qualityNames } from 'lib/players';

const Root = styled(Horizontal).attrs({ center: true })`
  gap: 1px;
  height: var(--double-and-a-half-unit);
  min-width: var(--quadruple-unit);
  padding: var(--half-unit) var(--half-unit);
  border-radius: 10px;
  border: 1px solid var(--c-nd-500);
  background: linear-gradient(
    to bottom right,
    transparent 50%,
    var(--c-nd-150) 51%
  );

  &.tierZero {
    color: var(--c-yellow-200);
  }
`;

type Props = {
  /*
  starRank is number value from  0 to 6
  it represents the Tier of the card
  */
  starRank: number;
  cardQuality?: CardQuality;
};

const MAX_STARS = 5;

export const StarRank = ({ starRank, cardQuality }: Props) => {
  const numberOfStars = Math.min(starRank, MAX_STARS);

  const tierZero = starRank > MAX_STARS;

  return (
    <ConditionalWrapper wrap={!!tierZero} Wrapper={Sparkles}>
      <Root className={classNames({ tierZero })}>
        {range(numberOfStars).map(i => (
          <Star key={i} size={1} />
        ))}
        {!!cardQuality && (
          <span className="sr-only">{qualityNames[cardQuality]}</span>
        )}
      </Root>
    </ConditionalWrapper>
  );
};
